// extracted by mini-css-extract-plugin
export default {"coursesContainer":"CourseItemList_coursesContainer__I5tar"};